// Rebeca Paris · componentes propios de la ficha. Se cargan en TODAS las páginas (sección custom-liquid del pie),
// así funcionan también dentro del "ajout rapide" y cuando el tema repinta la ficha (los <script> en línea no se
// vuelven a ejecutar ahí; un custom element sí, con connectedCallback).

const dos = (n) => String(n).padStart(2, '0');
const cuenta = (s) => {
  const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
  // Solo DOS unidades, que cuatro seguidas marean (Alex 20-sept: "hasta me lío viendo minutos, segundos y todo").
  // Queda: "10 jours" · "1 jour 4 h" · "6 h 20 min" · "12 min 30 s" según lo que falte.
  if (d >= 2) return d + ' jours';
  if (d === 1) return '1 jour ' + h + ' h';
  if (h >= 1) return h + ' h ' + dos(m) + ' min';
  return m + ' min ' + dos(s % 60) + ' s';
};

// 🔥 <rp-urgencia data-fin="ISO">: cuenta atrás al fin REAL de la oferta. Llega a cero → se quita. Nunca se reinicia.
class RpUrgencia extends HTMLElement {
  connectedCallback() {
    const fin = new Date(this.dataset.fin).getTime();
    const reloj = this.querySelector('[data-reloj]');
    if (!reloj || Number.isNaN(fin)) return this.remove();
    const pintar = () => {
      const s = Math.floor((fin - Date.now()) / 1000);
      if (s <= 0) { this.remove(); return; }
      reloj.textContent = cuenta(s); // solo los números: van dentro de la píldora naranja
    };
    pintar();
    this._t = setInterval(pintar, 1000);
  }
  disconnectedCallback() { clearInterval(this._t); }
}

// 🎰 <rp-rasca data-codigo="GRATTEZ10" data-reclamo="…">: capa dorada que se rasca y descubre un código REAL.
// Al descubrirlo se aplica al carrito por la Cart API y solo se dice "appliqué" si Shopify lo da por aplicable.
class RpRasca extends HTMLElement {
  connectedCallback() {
    this.codigo = this.dataset.codigo;
    this.clave = 'rp-rasca-' + this.codigo;
    this.lienzo = this.querySelector('canvas');
    this.nota = this.querySelector('[data-nota]');
    this.hecho = false;
    let guardado = false;
    try { guardado = !!localStorage.getItem(this.clave); } catch (e) {}
    // Ya rascado antes: se enseña el código, pero NO se reaplica en cada visita (auditoría Fable 18-sept)
    if (guardado || !this.lienzo) { this.#descubrir(false); return; }

    this.ctx = this.lienzo.getContext('2d');
    this.pasos = 0;
    this.#pintar();
    this._ro = new ResizeObserver(() => { if (!this.hecho && !this.pasos) this.#pintar(); });
    this._ro.observe(this);
    document.fonts?.ready.then(() => { if (!this.hecho && !this.pasos) this.#pintar(); });

    let ultimo = null, rascando = false;
    const pos = (e) => { const r = this.lienzo.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
    const borrar = ([x, y]) => {
      const c = this.ctx;
      c.globalCompositeOperation = 'destination-out';
      c.lineWidth = 44; c.lineCap = 'round'; c.lineJoin = 'round';
      c.beginPath();
      if (ultimo) { c.moveTo(ultimo[0], ultimo[1]); c.lineTo(x, y); c.stroke(); } else { c.arc(x, y, 22, 0, Math.PI * 2); c.fill(); }
      ultimo = [x, y];
    };
    const fin = () => { rascando = false; ultimo = null; if (!this.hecho && this.#porcentaje() > 0.5) this.#revelar(); };
    this.lienzo.addEventListener('pointerdown', (e) => { rascando = true; borrar(pos(e)); });
    this.lienzo.addEventListener('pointermove', (e) => {
      if (!rascando || this.hecho) return;
      borrar(pos(e));
      if (++this.pasos % 8 === 0 && this.#porcentaje() > 0.5) this.#revelar();
    });
    // pan-y: el dedo en vertical hace scroll (el navegador manda pointercancel); en horizontal, rasca
    ['pointerup', 'pointercancel', 'pointerleave'].forEach((t) => this.lienzo.addEventListener(t, fin));
    this.lienzo.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.#revelar(); } });
  }

  disconnectedCallback() { this._ro?.disconnect(); }

  #pintar() {
    const r = this.getBoundingClientRect(), dpr = window.devicePixelRatio || 1, c = this.ctx;
    if (!r.width) return;
    this.lienzo.width = r.width * dpr; this.lienzo.height = r.height * dpr;
    c.setTransform(dpr, 0, 0, dpr, 0, 0);
    const g = c.createLinearGradient(0, 0, r.width, r.height);
    g.addColorStop(0, '#b8964f'); g.addColorStop(0.45, '#e9d7a1'); g.addColorStop(0.55, '#f3e6bd'); g.addColorStop(1, '#b8964f');
    c.globalCompositeOperation = 'source-over';
    c.fillStyle = g; c.fillRect(0, 0, r.width, r.height);
    const fuente = getComputedStyle(this).fontFamily;
    c.fillStyle = '#5a4520'; c.textAlign = 'center'; c.textBaseline = 'middle';
    c.font = '700 22px ' + fuente;
    c.fillText(this.dataset.reclamo || 'GRATTEZ ET GAGNEZ !', r.width / 2, r.height / 2 - 8, r.width - 32);
    c.font = '400 13px ' + fuente;
    c.fillText('Grattez de gauche à droite', r.width / 2, r.height / 2 + 18, r.width - 32);
  }

  #porcentaje() {
    const d = this.ctx.getImageData(0, 0, this.lienzo.width, this.lienzo.height).data;
    let vacios = 0, total = 0;
    for (let i = 3; i < d.length; i += 64) { total++; if (d[i] === 0) vacios++; }
    return vacios / total;
  }

  #revelar() {
    if (this.hecho) return;
    this.#descubrir(true);
    try { localStorage.setItem(this.clave, '1'); } catch (e) {}
    this.#aplicar();
  }

  #descubrir(animado) {
    this.hecho = true;
    if (this.lienzo) {
      if (animado) { this.lienzo.style.opacity = '0'; setTimeout(() => this.lienzo?.remove(), 400); } else this.lienzo.remove();
    }
  }

  // Aplica el código al carrito AL RASCAR y cuenta la verdad
  async #aplicar() {
    if (!this.nota) return;
    try {
      const r = await fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: this.codigo }),
      });
      const cart = await r.json();
      const d = (cart.discount_codes || []).find((x) => x.code?.toUpperCase() === this.codigo);
      this.nota.textContent = d?.applicable
        ? '✓ Appliqué à votre panier'
        : cart.item_count
          ? 'Code non applicable à ce panier (non cumulable avec les packs, une utilisation par client)'
          : '✓ Code enregistré : il s’appliquera à votre panier';
    } catch (e) {
      this.nota.textContent = 'Saisissez le code au moment du paiement';
    }
    this.nota.hidden = false;
  }
}

if (!customElements.get('rp-urgencia')) customElements.define('rp-urgencia', RpUrgencia);
if (!customElements.get('rp-rasca')) customElements.define('rp-rasca', RpRasca);

// 🚚 <rp-envio data-dias="3">: "Expédiée au plus tard le lun. 21 sept." = hoy + N días laborables (sin fines de semana)
class RpEnvio extends HTMLElement {
  connectedCallback() {
    const el = this.querySelector('[data-fecha]');
    if (!el) return;
    let n = parseInt(this.dataset.dias, 10) || 0;
    if (n <= 0) return; // sin plazo real → sin fecha exacta (L216-1: el plazo anunciado obliga)
    const d = new Date();
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
    el.textContent = d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'long' });
  }
}

// 📏 <rp-guia>: abre la ventana de la guía de tallas y calcula la talla con las medidas de la clienta
class RpGuia extends HTMLElement {
  connectedCallback() {
    const ventana = this.querySelector('dialog');
    if (!ventana) return;
    // El listener delegado va en la SECCIÓN, que sobrevive a los repintados; sin AbortController se acumulaba uno por
    // cada vez que el tema reinserta el elemento y el primero llamaba a un <dialog> ya desconectado (auditor 20-sept).
    this._ac?.abort();
    this._ac = new AbortController();
    const { signal } = this._ac;
    this.querySelector('[data-abrir]')?.addEventListener('click', () => ventana.showModal(), { signal });
    // El enlace "Guide des tailles" vive DENTRO de la línea de la talla (snippets/variant-main-picker.liquid), fuera de
    // este bloque y repintado cada vez que se cambia de variante: se escucha delegado en toda la sección (Alex 20-sept).
    const ambito = this.closest('.shopify-section, dialog') || document;
    ambito.addEventListener('click', (e) => {
      const disparador = e.target instanceof Element ? e.target.closest('[data-abrir-guia]') : null;
      if (!disparador || !this.isConnected) return;
      this._origen = disparador;  // para devolverle el foco al cerrar
      ventana.showModal();
    }, { signal });
    this.querySelector('[data-cerrar]')?.addEventListener('click', () => ventana.close());
    ventana.addEventListener('click', (e) => {
      const c = ventana.getBoundingClientRect();
      const fuera = e.clientX < c.left || e.clientX > c.right || e.clientY < c.top || e.clientY > c.bottom;
      if (fuera) ventana.close();
    });
    // Al cerrar, el foco vuelve al enlace que la abrió (el de la línea de la talla); el botón propio está oculto
    // requestAnimationFrame: si se enfoca dentro del propio 'close', el navegador lo pisa y el foco cae al <body>
    ventana.addEventListener('close', () => requestAnimationFrame(() =>
      (this._origen || this.querySelector('[data-abrir]'))?.focus()), { signal });
    const filas = [...this.querySelectorAll('tr[data-talla]')].map((tr) => ({
      tr, talla: tr.dataset.talla,
      max: tr.dataset.medidas.split('|').map((r) => parseFloat(String(r).split(/[–-]/).pop())),
    }));
    const campos = [...this.querySelectorAll('input[data-m]')];
    const res = this.querySelector('[data-resultado]');
    const calcular = () => {
      const m = campos.map((c) => parseFloat(c.value));
      filas.forEach((f) => f.tr.classList.remove('rp-guia--tuya'));
      if (m.every(Number.isNaN)) { res.textContent = ''; return; }
      // la talla más pequeña en la que todas las medidas indicadas caben
      const f = filas.find((f) => m.every((v, i) => Number.isNaN(v) || v <= f.max[i]));
      if (f) { f.tr.classList.add('rp-guia--tuya'); res.textContent = `Votre taille : ${f.talla}`; }
      else res.textContent = 'Vos mesures dépassent notre guide : écrivez-nous, nous vous conseillerons.';
    };
    campos.forEach((c) => c.addEventListener('input', calcular));
  }

  disconnectedCallback() {
    this._ac?.abort();
  }
}

if (!customElements.get('rp-envio')) customElements.define('rp-envio', RpEnvio);
if (!customElements.get('rp-guia')) customElements.define('rp-guia', RpGuia);

// 🟢 <rp-insignia data-block-id>: la insignia de descuento se repinta al cambiar de variante (mismo evento que el precio
// de Horizon: StandardEvents.productSelect → detail.html trae la sección nueva). Auditoría Fable 18-sept.
const { StandardEvents } = await import('@shopify/events').catch(() => ({}));
class RpInsignia extends HTMLElement {
  connectedCallback() {
    this._seccion = this.closest('.shopify-section, dialog');
    const ev = StandardEvents?.productSelect;
    if (!this._seccion || !ev) return;
    this._ev = ev;
    this._h = (e) => {
      if (!(e.target instanceof Element) || e.target.closest('product-card')) return;
      e.promise?.then(({ detail }) => {
        const nueva = detail?.html?.querySelector(`rp-insignia[data-block-id="${this.dataset.blockId}"]`);
        if (nueva) this.innerHTML = nueva.innerHTML;
      }).catch(() => {});
    };
    this._seccion.addEventListener(ev, this._h);
  }
  disconnectedCallback() { if (this._ev) this._seccion?.removeEventListener(this._ev, this._h); }
}
if (!customElements.get('rp-insignia')) customElements.define('rp-insignia', RpInsignia);

// ⏱️ <rp-corte data-hora="15">: cuenta atrás REAL al corte de expedición de HOY (Alex 20-sept). Se reinicia sola cada
// día a la hora del corte; fines de semana cuenta al lunes, porque no se expide en sábado ni domingo.
// Nada de plazos inventados: solo hay que cumplir que lo que entre antes de esa hora se tramita ese mismo día.
const enParis = (d = new Date()) => {
  const p = Object.fromEntries(new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', hour12: false,
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' })
    .formatToParts(d).map((x) => [x.type, x.value]));
  return { fecha: `${p.year}-${p.month}-${p.day}`, reloj: new Date(`${p.year}-${p.month}-${p.day}T${p.hour === '24' ? '00' : p.hour}:${p.minute}:${p.second}Z`) };
};
const proximoCorte = (hora) => {
  const { fecha, reloj } = enParis();
  let objetivo = new Date(`${fecha}T${String(hora).padStart(2, '0')}:00:00Z`);
  if (objetivo <= reloj) objetivo = new Date(objetivo.getTime() + 86400000);
  let dia = objetivo.getUTCDay();                       // 0 domingo · 6 sábado
  while (dia === 0 || dia === 6) { objetivo = new Date(objetivo.getTime() + 86400000); dia = objetivo.getUTCDay(); }
  return { ms: objetivo.getTime() - reloj.getTime(), hoy: objetivo.toISOString().slice(0, 10) === fecha };
};
customElements.get('rp-corte') || customElements.define('rp-corte', class extends HTMLElement {
  connectedCallback() {
    const hora = +(this.dataset.hora || 15);
    const reloj = this.querySelector('[data-reloj]');
    const cuando = this.querySelector('[data-cuando]');
    if (!reloj) return;
    const pinta = () => {
      const { ms, hoy } = proximoCorte(hora);
      reloj.textContent = cuenta(Math.max(0, Math.floor(ms / 1000)));
      if (cuando) cuando.textContent = hoy ? this.dataset.hoy || "expédiée aujourd'hui" : this.dataset.siguiente || 'expédiée le prochain jour ouvré';
      // 9-oct (Alex: "no quiero fallos"): en la ficha, si el corte ya no es HOY (noche o fin de semana) la línea se esconde:
      // "Commandez dans les 2 jours" sonaba raro. Solo sale cuando de verdad se tramita hoy.
      if (this.classList.contains('rp-corte-ficha')) this.style.display = hoy ? '' : 'none';  // (no vale hidden: su CSS fuerza display:block)
    };
    pinta();
    this._t = setInterval(pinta, 1000);
  }
  disconnectedCallback() { clearInterval(this._t); }
});

